import * as React from 'react';

// Native <select> facet — same control the axis switcher / grouped dropdown
// use, so all sidebar dropdowns share one style. Single-value: picking an option
// replaces the current selection. count===0 options are disabled for subsequent
// facets (the first facet always stays fully selectable).
export function DropdownFacet(props) {
  const {options, onChange: setFilter, initialFacetValues = [], isFirstFacet = false, label} = props;

  // Auto-cascade for subsequent facets: if the current selection has count=0,
  // replace it with the first valid option in a single state update.
  React.useEffect(() => {
    if (isFirstFacet) return;

    const selected = options.find(o => o.selected);
    if (selected && selected.count > 0) return;

    const firstValid = options.find(o => o.count > 0);
    if (firstValid) setFilter(firstValid.value);
  }, [options, isFirstFacet]);

  const merged = React.useMemo(() => {
    const existing = new Map(options.map(o => [o.value, o]));
    const missing = initialFacetValues
      .filter(v => !existing.has(v))
      .map(v => ({value: v, count: 0, selected: false}));
    return [...options, ...missing].sort((a, b) => String(a.value).localeCompare(String(b.value)));
  }, [options, initialFacetValues]);

  const selectedItem = merged.find(o => o.selected);

  return (
    <select
      className="nv-chart__facet-select"
      // FilterWrapper shows the facet name as a visual <strong>, not a <label>,
      // so without this the control announces as an unnamed combobox.
      aria-label={label}
      value={selectedItem?.value ?? ''}
      onChange={(event) => setFilter(event.target.value)}
    >
      {!selectedItem && <option value="" disabled>Select...</option>}
      {merged.map(option => (
        <option key={option.value} value={option.value} disabled={!isFirstFacet && option.count === 0}>
          {option.value}
        </option>
      ))}
    </select>
  );
}
